import SectionTitle from "@/components/feature/SectionTitle";
import { stats, testimonials } from "@/mocks/site";

export default function TestimonialsSection() {
  return (
    <section className="w-full px-4 py-14 md:px-8 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14">
        <div>
          <SectionTitle
            eyebrow="网站口碑"
            title="每天有一批人，用 10 分钟把瓜吃完"
            desc="他们把这里当成通勤路上的信息站，不看剧透、不站队，只想快速了解发生了什么。"
          />

          <dl className="mt-8 grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-card border border-background-200 bg-background-50 p-4">
                <dt className="text-xs text-foreground-500">{s.label}</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {s.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="flex flex-col gap-5">
          {testimonials.map((t, index) => (
            <blockquote
              key={t.name}
              className={`rounded-card border p-5 md:p-6 ${
                index === 1
                  ? "border-accent-200 bg-accent-50"
                  : "border-background-200 bg-background-50"
              }`}
            >
              <i className="ri-double-quotes-l text-2xl text-primary-400" />
              <p className="mt-2 text-sm leading-relaxed text-foreground-700 md:text-base">{t.text}</p>
              <footer className="mt-4 flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-semibold text-secondary-900">
                  {t.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block font-heading text-sm font-semibold text-foreground-950">{t.name}</span>
                  <span className="block text-xs text-foreground-500">{t.role}</span>
                </span>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}